module.exports = __webpack_public_path__ + "img/qu_dk.4429c4f.jpg";